import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { FadeIn } from "@/components/Reveal";
import SEO from "@/components/SEO";

const IMAGE_FOCUS = {
  "ach-2023-rex": "object-bottom",
  "ach-2022-solvex": "object-top",
};

export default function Achievements() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/achievements").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  if (!items) return <div className="min-h-screen bg-[#0A0A0A]" data-testid="achievements-loading" />;

  return (
    <main data-testid="achievements-page">
      <SEO
        title="Achievements & Awards — Catalyst Petrochem LLP"
        description="Ten years of milestones: NHAI source approvals, national bio-bitumen recognition, and industry awards celebrating Catalyst Petrochem's contribution to India's roads."
        path="/achievements"
      />
      <PageHeader
        index="03"
        tag="Achievements"
        title="A decade of proof."
        description="Awards, source approvals and technology partnerships — from NHAI credential verifications to national recognition for bio-bitumen innovation."
      />
      <section className="px-6 py-20 md:px-12 md:py-28 lg:px-20">
        <div className="relative ml-2 border-l border-white/10 pl-8 md:ml-4 md:pl-12" data-testid="achievements-timeline">
          {items.map((a, i) => (
            <FadeIn key={a.id} delay={i * 0.06} className="relative pb-20 last:pb-0">
              <span className="absolute -left-[41px] top-1.5 h-4 w-4 rotate-45 border border-brand bg-[#0A0A0A] shadow-[0_0_18px_rgba(255,87,34,0.55)] md:-left-[57px]" />
              <div className={`grid gap-8 ${a.image ? "md:grid-cols-12 md:items-center" : ""}`}>
                <div className={a.image ? "md:col-span-7" : ""}>
                  <p className="font-mono text-xs tracking-[0.2em] text-brand" data-testid={`achievement-year-${i}`}>
                    {a.year} · {a.tag}
                  </p>
                  <h2 className="mt-3 max-w-3xl font-display text-2xl font-medium uppercase tracking-normal md:text-4xl">
                    {a.title}
                  </h2>
                  <p className="mt-4 max-w-2xl text-sm leading-relaxed text-neutral-400 md:text-base">{a.description}</p>
                </div>
                {a.image && (
                  <div className={`md:col-span-5 ${i % 2 === 1 ? "md:order-first" : ""}`}>
                    <div className="group overflow-hidden rounded-2xl border border-white/10">
                      <img
                        src={a.image}
                        alt={a.title}
                        loading="lazy"
                        data-testid={`achievement-image-${i}`}
                        className={`h-64 w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105 md:h-80 ${IMAGE_FOCUS[a.id] || "object-center"}`}
                      />
                    </div>
                  </div>
                )}
              </div>
            </FadeIn>
          ))}
        </div>
      </section>
    </main>
  );
}
